// Extracted from web/App.tsx; behavior and declaration bodies preserved.
import { useEffect, useState } from "react";
import type { ComponentType } from "react";

import { LoaderCircle } from "lucide-react";
import type { Session } from "../../shared/contracts";
import { api, captureSession } from "../api";

import { errorText } from "../components/Primitives";
import { Brand } from "../foundation/Brand.js";
import { Authentication } from "../repository/Authentication.js";
import { Workspace } from "./Workspace.js";

import type { ModelCanvasProps } from "../diagram/contracts.js";
export default function App({ ModelCanvas }: { ModelCanvas: ComponentType<ModelCanvasProps> }) {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);
  const [needsSetup, setNeedsSetup] = useState(false);
  const [requiresToken, setRequiresToken] = useState(false);
  const [bootError, setBootError] = useState("");
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const result: any = await api("/auth/session");
        if (alive) {
          const s = result.session || result;
          captureSession(s);
          setSession(s);
        }
      } catch {
        try {
          const status: any = await api("/setup/status");
          if (alive) {
            setNeedsSetup(status.needsSetup);
            setRequiresToken(status.requiresSetupToken);
          }
        } catch (e) {
          if (alive) setBootError(errorText(e));
        }
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);
  if (loading)
    return (
      <div className="boot-screen">
        <Brand large />
        <LoaderCircle className="spin" size={23} />
        <p>Opening your workspace…</p>
      </div>
    );
  if (!session)
    return (
      <Authentication
        setup={needsSetup}
        requiresToken={requiresToken}
        initialError={bootError}
        onSession={(s) => {
          captureSession(s);
          setSession(s);
        }}
      />
    );
  return (
    <Workspace
      ModelCanvas={ModelCanvas}
      session={session}
      onSession={(s) => {
        captureSession(s);
        setSession(s);
      }}
      onLogout={() => setSession(null)}
    />
  );
}
